import { bucketScore } from './scoring';
import type { Mode, ResultTypeId } from './types';

export type AnalyticsEvent =
  | { name: 'mode_selected'; locale: string; mode: Mode }
  | { name: 'assessment_started'; locale: string; mode: Mode }
  | { name: 'scenario_advanced'; locale: string; mode: Mode; position: number }
  | {
      name: 'assessment_completed';
      locale: string;
      mode: Mode;
      scoreBucket: string;
      typeId: ResultTypeId;
    }
  | { name: 'boundary_opened'; locale: string; mode: Mode }
  | { name: 'review_opened'; locale: string; mode: Mode }
  | {
      name: 'share_requested';
      locale: string;
      method: 'native' | 'download' | 'copy' | 'x' | 'instagram' | 'xiaohongshu' | 'weibo';
    };

declare global {
  interface Window {
    __THE_LINE_ANALYTICS__?: (event: AnalyticsEvent) => void;
  }
}

export function track(event: AnalyticsEvent): void {
  window.dispatchEvent(new CustomEvent<AnalyticsEvent>('the-line:analytics', { detail: event }));
  window.__THE_LINE_ANALYTICS__?.(event);
}

export function completedEvent(
  locale: string,
  mode: Mode,
  score: number,
  typeId: ResultTypeId,
): AnalyticsEvent {
  return {
    name: 'assessment_completed',
    locale,
    mode,
    scoreBucket: bucketScore(score),
    typeId,
  };
}
